import React from 'react';
import logo from '../../img/navlogo.png';
import './Header.css';
const Header = () => {
    return (
        <nav className='header'>
            <img src={logo} alt="" />
            <div>
                <div>
                    {/* <a href="/shop">Shop</a>
                    <a href="/orders">Orders</a>
                    <a href="/inventory">Inventory</a> */}
                    <a href="/about">About</a>
                    <a href="/contact">Contact US</a>
                </div>
            </div>
        </nav>
    );
};

export default Header;